export default "__VITE_ASSET__iQbM$Too__"